<template>
    <div class="form-group" @keydown.enter.prevent.self>
        <label v-if="label" :for="name">{{label}}</label>
        <v-select :options="options" :id="name" :name="name" v-model="vModel" :label="labelField" :multiple="multiple"
                  :disabled="disabled" :placeholder="placeholder" dir="rtl" @input="onChange" />
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                required: true
            },

            options: {
                type: [Array],
                required: true
            },

            labelField: {
                type: String,
                required: true
            },

            valueField: {
                type: String
            },

            multiple: {
                type: Boolean
            },

            disabled: {
                type: Boolean
            }
        },

        computed: {
            placeholder() {
                return `${this.Lang.get('messages.select')} ${this.label}`;
            },

            vModel: {
                get: function () {
                    return _.get(this.model, this.name);
                },
                // setter
                set: function (newValue) {
                    _.set(this.model, this.name, newValue);
                }

            }
        },
        watch: {
            options(newVal, oldVal) {
                let newIDs = newVal.map(item => item.id);
                let currentModel = _.get(this.model, this.name);
                // Check if model is array
                if (Array.isArray(currentModel)) {
                    // filter model
                    let newModel = currentModel.filter(function (el) {
                        return newIDs.includes(el.id);
                    });
                    _.set(this.model, this.name, newModel);
                }
            }
        },

        methods: {
            onChange(value) {
                this.$emit('change', value);
            }
        }
    };

</script>

<style>
</style>
